import { render } from "./ClaimDynamicAccount.vue?vue&type=template&id=445774be&scoped=true"
import script from "./ClaimDynamicAccount.vue?vue&type=script&lang=js"
export * from "./ClaimDynamicAccount.vue?vue&type=script&lang=js"

import "./ClaimDynamicAccount.vue?vue&type=style&index=0&id=445774be&scoped=true&lang=css"

import exportComponent from "/home/peter/new-demo-tool/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-445774be"]])

export default __exports__